import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/46_autumn/46_autumn"
 * Contains 1 texture(s)
 */
export class Mobile46AutumnAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/46_autumn/46_autumn';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '46_autumn.jpg'
    ] as const;
}
